module.exports = __webpack_public_path__ + "media/images/brands/marque-lci@2x-428dd841e2e0de9976266911a827a855.jpg";